import CAFlex from '@ds/components/containers/CAFlex'
import CALink from '@ds/components/navigation/CALink'
import CAIcon from '@ds/components/shared/CAIcon'
import { useGlobalStore } from '@vuejs/stores/GlobalStore'
import { defineComponent } from 'vue'

import t, { initTranslations } from '@/javascript/lib/i18next'
import { es } from '@/javascript/locales/es.json'

export default defineComponent({
	name: 'SimpleHeader',

	props: { hideLogout: { default: false, type: Boolean } },

	computed: {
		globalStore(): ReturnType<typeof useGlobalStore> {
			return useGlobalStore()
		},
	},

	beforeMount() {
		initTranslations()
	},

	render() {
		return (
			<div class="simple-header" data-test="simple-header">
				<CAFlex
					align="center"
					class="w-full simple-header__flex-box"
					justify="between"
				>
					<div class="logo-container">
						<CALink
							class="logo logo--on-member-dashboard"
							data-test="careacademy-logo"
							href="/"
						>
							<CAIcon
								aria-labelledby="CareAcademy logo"
								class="logo__image careacademy-logo"
								icon="SVGCareAcademyFull"
							/>
						</CALink>
					</div>

					{!this.hideLogout &&
						<div class="logout-container">
							<a
								class="capitalize ca-link__default hover:underline"
								data-method="delete"
								data-test="logout-link"
								href="/users/sign_out"
								rel="nofollow"
							>
								{this.globalStore.selectedLanguage === 'es'
									? es.global.logout
									: t('global.logout')}
							</a>
						</div>
					}
				</CAFlex>
			</div>
		)
	},
})
